import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Scrollbars from 'react-custom-scrollbars-2';
import AddIngredients from '../../../components/OrderAnItem/ItemCustomization/AddIngredients';
import { FULL_SIZE, HALF_SIZE, SINGLE_ITEM_SELECTED_SECTION } from '../../../constants';
import { IModifiersObjects } from '../../../models/try2Combo';
import { isItCreateYourOwnItem } from '../../../helpers/helperMethods';
import { getItemTotal} from '../../../priceCalculation/helper';
import EventBusForBYOCategoryScrollingBetweenAccordions from '../../../utils/EventBusForBYOCategoryScrollingBetweenAccordions';
import { PULSE_VIEW_ID, trackPulseView } from '../../../analytics/pulseViewIds';

interface ICustomizationModal {
  modalShow: boolean;
  onModalCancel: () => void;
  item: any;
  handleIngredientSelection: (data: any, id?: number) => void;
  handleSyncIngredients: (item: any) => void;
  styleClasses: { readonly [key: string]: string; };
  applyClickHandler: () => void;
  isItEdit?: boolean;
  showCustomization?: boolean;
  CYOIScrollToMissingRequiredArea?:{
    refToScrollToMissingRequiredArea: any[];
    isCYOIRequiredModifierSelected: {
      status: boolean;
      highLightArea: number;
    };
    setIsCYOIRequiredModifierSelected: React.Dispatch<
      React.SetStateAction<{ status: boolean; highLightArea: any }>
    >;
  }
  order:any;
  itemAsModifierState?: {
    itemsAsModifier: any[];
    setItemsAsModifier: (v: any) => void;
  };
  openItemInfoModal?: (item: any) => void;
}

const CustomizationModal: React.FC<ICustomizationModal> = (props) => {
  const {
    modalShow,
    onModalCancel,
    item,
    handleIngredientSelection,
    handleSyncIngredients,
    styleClasses,
    applyClickHandler,
    isItEdit,
    showCustomization,
    CYOIScrollToMissingRequiredArea,
    order,
    itemAsModifierState,
    openItemInfoModal,
  } = props;

  const isThisCreateYourOwnItem = isItCreateYourOwnItem(item?.is_create_your_own);
  const [itemPrice, setItemPrice] = useState(null);

  useEffect(() => {
    if (modalShow) {
      trackPulseView(PULSE_VIEW_ID.CUSTOMIZATION_MODAL, {
        page_path: window.location.pathname,
      });
    }
  }, [modalShow]);

  useEffect(() => {
      setItemPrice(price())
  }, [order]);

  const modalHeading = () => {
    if(isThisCreateYourOwnItem){
      return `${item.category_name} - ${item.name}`;
    }
    return 'Customize This Item';
  }

  const price = () => {
    let itemPrice = item.price;
    if(order.size === HALF_SIZE.id){
      itemPrice = item.half_brink_item_price;
    }
    const price = getItemTotal(item, order, itemPrice, order.size ?? FULL_SIZE.id) + order?.display_price;
    return price.toFixed(2)
  }

  return (
    <Modal
      scrollable={false}
      show={modalShow}
      onHide={onModalCancel}
      centered
      id="modal_handle_for_byo_items"
      className="theme-modal-style app_container_wrap no-padding border-radius-15 border-radius-sm-12 upperside-radius-sm-only item-customization--modal bowl-customization-modal"
    >
      <Modal.Header className="pt-0" id="close_button2">
        <button
          type="button"
          className="btn modal-close-button pe-0 sm-blue-icon"
          onClick={onModalCancel}
        >
          Close
        </button>
      </Modal.Header>
      <Modal.Body className={` px-2 px-md-0 text-center`}>
        <h2
          className={`font-Cls f-s22 f-sm-s17 ls-normal lh-normal text-center ${
            isThisCreateYourOwnItem && 'text-uppercase'
          }`}
        >
          {modalHeading()}
        </h2>
        <h6 className="font-Cls f-s22 f-sm-s17 ls-normal lh-normal text-start ms-3 mb-0">
          Total: ${itemPrice}
        </h6>
        <Scrollbars className="Modal_inner_scrollbar customization_inner_scrollbar">
          <AddIngredients
            modifierGroups={item?.items_modifier_groups}
            coreModifiers={item?.core_modifiers}
            requiredModifiers={item?.items_required_modifier_groups}
            itemsAsModifiers={item?.sub_items_required_modifier_groups}
            itemAsModifierState={itemAsModifierState}
            parentTrayItem={item}
            openItemInfoModal={openItemInfoModal}
            handleIngredientSelection={(data: IModifiersObjects) =>
              handleIngredientSelection(data, SINGLE_ITEM_SELECTED_SECTION)
            }
            selectedItem={SINGLE_ITEM_SELECTED_SECTION.toString()}
            handleSyncIngredients={handleSyncIngredients}
            sectionSelected={SINGLE_ITEM_SELECTED_SECTION.toString()}
            itemName={item?.name}
            is_create_your_own={item?.is_create_your_own}
            isItEdit={isItEdit}
            showCustomization={showCustomization}
            itemModifierItemModalWidth={'item__modifier_item_modal_width'}
            CYOIScrollToMissingRequiredArea={CYOIScrollToMissingRequiredArea}
          />
        </Scrollbars>
        <button
          type="button"
          className={`${styleClasses.order_item_order_btn} btn btn-large ms-0 mt-3`}
          onClick={() => {
            const eventResult =
              EventBusForBYOCategoryScrollingBetweenAccordions.emit(
                'checkForMissingRequiredModifers'
              );
            if (eventResult?.length > 0 && eventResult[0].status) {
              EventBusForBYOCategoryScrollingBetweenAccordions.emit(
                'updateMissingRequiredRefCurrentMissingIndex',
                eventResult[0].missingGroupIndex
              );
              EventBusForBYOCategoryScrollingBetweenAccordions.emit(
                'refUpdatedForBuildYourOwnRequiredScrollOnAddOnsAccorionClick',
                EventBusForBYOCategoryScrollingBetweenAccordions.getState()
              );
              setTimeout(() => {
                EventBusForBYOCategoryScrollingBetweenAccordions.emit(
                  'scrollToMissingIndex',
                  {
                    status: true,
                    missingGroupIndex: eventResult[0].missingGroupIndex,
                    startScrollingFor: 'required',
                    limitForCompareType: 'min',
                  }
                );
              }, 300);
            } else {
              applyClickHandler();
            }
          }}
        >
          {isThisCreateYourOwnItem ? 'BUILD' : 'Apply'}
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default CustomizationModal;
